import { Route } from '@angular/router';

export const routes: Route[] = [

  // Admin
  {
    path: '',
    loadChildren: () => import('./domains/admin/routes'),
  },
  
];
